module.exports = __webpack_public_path__ + "static/img/yytb.5d74df92.png";